module.exports = __webpack_public_path__ + "img/bg-icon.f2f5fa2c.png";